var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFloridaSmartId(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "240.000000pt",
    height: "240.000000pt",
    viewBox: "0 0 240.000000 240.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,240.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M510 1195 l0 -805 135 0 135 0 0 805 0 805 -135 0 -135 0 0 -805z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1020 1194 l0 -806 248 5 c271 5 341 15 469 69 265 109 429 338 459 638 l7 70 -135 0 -135 0 -7 -60 c-14 -126 -69 -235 -159 -316 -96 -86 -222 -130 -389 -136 l-93 -3 -3 543 -2 542 50 0 50 0 0 130 0 130 -180 0 -180 0 0 -806z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1440 1951 l0 -51 48 0 c69 0 155 -24 252 -72 108 -52 225 -167 283 -275 42 -81 77 -203 77 -275 l0 -48 51 0 52 0 -6 68 c-10 100 -32 177 -81 277 -119 241 -337 390 -613 421 l-63 7 0 -52z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1440 1710 l0 -50 35 0 c20 0 63 -9 97 -21 152 -51 261 -180 289 -341 l11 -68 44 0 44 0 0 38 c0 53 -24 136 -61 211 -65 131 -215 243 -363 270 -97 18 -96 18 -96 -39z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1440 1466 c0 -48 1 -49 52 -60 57 -13 128 -96 128 -151 0 -24 3 -25 51 -25 l51 0 -7 38 c-23 126 -115 223 -228 238 l-47 7 0 -47z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1409 1276 c-18 -8 -25 -21 -27 -48 -3 -31 1 -40 24 -54 23 -16 29 -16 52 -3 32 18 44 50 29 79 -16 30 -48 41 -78 26z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFloridaSmartId);
export default __webpack_public_path__ + "static/media/florida_smart_id.21ae358ca32e1d27cb687c73d1e8fbab.svg";
export { ForwardRef as ReactComponent };